import { render, staticRenderFns } from "./TypeBlock.vue?vue&type=template&id=3f888ada"
import script from "./TypeBlock.vue?vue&type=script&lang=js"
export * from "./TypeBlock.vue?vue&type=script&lang=js"
import style0 from "./TypeBlock.vue?vue&type=style&index=0&id=3f888ada&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports